module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "xgallery-container"
  }, [_c('div', {
    staticClass: "xgallery-slider"
  }, [_c('img', {
    attrs: {
      "id": "xgalleryImage",
      "src": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xdots-container",
    attrs: {
      "id": "xdotsContainer"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1f5a2961", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f5a2961","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/ImageSlider.vue
// module id = 2051
// module chunks = 0